/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {Owner} from 'auth/PermissionConstants';
import {convertCollaborationsToCollaborators} from 'auth/PermissionUtil';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {UpdateOwnableParams} from 'create-components/OwnableConstants';
import {OwnableSettingsWithCollaborationsModal} from 'create-components/OwnableSettingsModal';
import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import TemplateCollectionActions from 'notebook/entry-templates/collections/TemplateCollectionActions';
import {CreateTemplateParams} from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import TemplateCollectionDAO from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import notifications from 'notifications';

import {OwnerScopedReviewProcessSection} from './TemplateCollectionReviewProcessSection';
import {persistReviewLifecycle} from './TemplateCollectionReviewProcessUtils';

interface Props {
  onRequestClose: (...args: Array<any>) => any;
}

interface State {
  reviewLifecycleIds: Set<string>;
}

class CreateTemplateCollectionModal extends React.Component<Props, State> {
  override state: State = {reviewLifecycleIds: new Set()};

  private clearReviewLifecycleSelection = (): void => {
    this.setState({reviewLifecycleIds: new Set()});
  };

  private toggleReviewLifecycleId = (reviewLifecycleId: string): void => {
    this.setState((state) => {
      const reviewLifecycleIds = new Set(state.reviewLifecycleIds);
      if (reviewLifecycleIds.has(reviewLifecycleId)) {
        reviewLifecycleIds.delete(reviewLifecycleId);
      } else {
        reviewLifecycleIds.add(reviewLifecycleId);
      }
      return {reviewLifecycleIds};
    });
  };

  private removeReviewLifecycleId = (reviewLifecycleId: string): void => {
    this.setState((state) => {
      const reviewLifecycleIds = new Set(state.reviewLifecycleIds);
      reviewLifecycleIds.delete(reviewLifecycleId);
      return {reviewLifecycleIds};
    });
  };

  private renderReviewProcessSection = ({
    isPosting,
    owner,
  }: {
    isPosting?: boolean;
    owner: Owner;
  }): JSX.Element | null => {
    if (!BenchlingConfig.ELN_ENABLE_TEMPLATE_REVIEWS) {
      return null;
    }
    return (
      <OwnerScopedReviewProcessSection
        owner={owner}
        reviewLifecycleIds={this.state.reviewLifecycleIds}
        onOwnerScopeChange={this.clearReviewLifecycleSelection}
        toggleReviewLifecycleId={this.toggleReviewLifecycleId}
        removeReviewLifecycleId={this.removeReviewLifecycleId}
        isReadOnly={Boolean(isPosting)}
      />
    );
  };

  private saveReviewLifecycleAfterCreate = (collectionId: string): Promise<void> => {
    if (!BenchlingConfig.ELN_ENABLE_TEMPLATE_REVIEWS || this.state.reviewLifecycleIds.size === 0) {
      return Promise.resolve();
    }
    return persistReviewLifecycle(collectionId, this.state.reviewLifecycleIds);
  };

  createCollection = async ({
    name,
    description,
    owner,
    collaborators,
    ownerInfo,
  }: CreateTemplateParams): Promise<any> => {
    try {
      const templateCollectionResponse = await TemplateCollectionDAO.create({
        name,
        description,
        owner,
        collaborators,
        ownerInfo,
      });
      // A newly created collection has no existing reviews to retract. Keep this awaited so the
      // create flow stays deterministic before opening the collection.
      await this.saveReviewLifecycleAfterCreate(templateCollectionResponse.id);
      writeFragmentsToCache(getFragmentWrapper('TemplateCollectionSummary'), [
        {
          __typename: 'TemplateCollectionNode',
          ...templateCollectionResponse,
        },
      ]);
      TemplateCollectionActions.openCollection(templateCollectionResponse);
      return templateCollectionResponse;
    } catch (error) {
      // OwnableSettingsModal only surfaces errors with a responseJSON body; notify here for transport
      // failures so the user still gets feedback before the modal clears posting.
      if ((error as {responseJSON?: unknown})?.responseJSON == null) {
        notifications.notifyError(error);
      }
      throw error;
    } finally {
      $('#fileLoading').addClass('hidden');
    }
  };

  override render(): JSX.Element {
    return (
      <OwnableSettingsWithCollaborationsModal
        onRequestClose={this.props.onRequestClose}
        ownableType={ModelTypeConstants.TEMPLATE_COLLECTION}
        navigateOnSuccess={false}
        customSettingsComponent={this.renderReviewProcessSection}
        doSubmit={(data: UpdateOwnableParams) =>
          this.createCollection({
            ...data,
            collaborators:
              data.collaborations &&
              convertCollaborationsToCollaborators(data.collaborations.filter((c) => !c.fromOwnership)),
          })
        }
        analyticsModule={ANALYTICS_MODULE.ELN}
        analyticsModalType="create_template_collection"
      />
    );
  }
}

export default CreateTemplateCollectionModal;
